module.exports = __webpack_public_path__ + "img/SKMJ_restform.e177ed97.png";